import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
//import TrendingUp from "@material-ui/icons/TrendingUp";
// core components
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Info from "components/Typography/Info.jsx";
// import Success from "components/Typography/Success.jsx";
// import Danger from "components/Typography/Danger.jsx";

import malls from "assets/img/Kinos/Properties/Thumbnails/malls.jpg";
import offices from "assets/img/Kinos/Properties/Thumbnails/offices.jpg";
import hotels from "assets/img/Kinos/Properties/Thumbnails/hotel.jpg";
import industrial from "assets/img/Kinos/Properties/Thumbnails/industrial.jpg";
import retail from "assets/img/Kinos/Properties/Thumbnails/retail.jpg";
import ruralLands from "assets/img/Kinos/Properties/Thumbnails/rural_lands-bg.jpg";
import bo_offer from "assets/img/Kinos/Properties/Thumbnails/projects.jpg";
// import lands from "assets/img/Kinos/lands.jpg";
import urbanLands from "assets/img/Kinos/Properties/Thumbnails/urban_lands.jpeg";
import buildings from "assets/img/Kinos/Properties/Thumbnails/buildings.jpg";
import residential from "assets/img/Kinos/Properties/Thumbnails/residential.jpg";
import new_developments from "assets/img/Kinos/Properties/Thumbnails/new_developments.jpg";
import investments from "assets/img/Kinos/Properties/Thumbnails/investments01.jpg";

import sectionInterestedStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionInterestedStyle.jsx";

function SectionProperties({ ...props }) {
  const { classes } = props;
  const { stats } = props;
  return (
    <div className={classes.section}>
      <h3 className={classes.title + " " + classes.textCenter}>
        You may be interested in...
      </h3>
      <br />
      <GridContainer>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}   id="retail">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/retail" className={classes.dropdownLink}>
                <img src={retail} alt="Retail" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + retail + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.locales.count} retail store for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/retail" className={classes.dropdownLink}>
                  RETAIL
                </Link>
              </h4>
              <p className={classes.description}>
                Helping clients to develop strategy, crete framework for decision making appraising property...
                <Link to="/retail" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="industrial">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/industrial" className={classes.dropdownLink}>
                <img src={industrial} alt="Industrial" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + industrial + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.naves.count} industrial facilities for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/industrial" className={classes.dropdownLink}>
                  INDUSTRIAL
                </Link>
              </h4>
              <p className={classes.description}>
                Use your family office to stay focused on future legacy...
                <Link to="/industrial" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="offices">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/offices" className={classes.dropdownLink}>
                <img src={offices} alt="Offices" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + offices + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.oficinas.count} offices for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/offices" className={classes.dropdownLink}>
                  OFFICES
                </Link>
              </h4>
              <p className={classes.description}>
                Whether investing in a home, buy-to-let property or a portfolio of assets, our dedicated teams cover all areas of financial advice, helping clients to make intelligent decisions based on market and sector insights...
                <Link to="/offices" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="buildings">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/buildings" className={classes.dropdownLink}>
                <img src={buildings} alt="Buildings" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + buildings + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.edificios.count} buildings for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/buildings" className={classes.dropdownLink}>
                  BUILDINGS
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide advice and analysis to clients across the Spain, with specialists in commercial, residentiall and world property research...
                <Link to="/buildings" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="hotels">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/hotels" className={classes.dropdownLink}>
                <img src={hotels} alt="Hotels" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + hotels + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.hoteles.count} hotels in sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/hotels" className={classes.dropdownLink}>
                  HOTELS
                </Link>
              </h4>
              <p className={classes.description}>
                When it comes to buying and selling property
wea advise across all residential and commercial
markets...
                <Link to="/hotels" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="malls">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/malls" className={classes.dropdownLink}>
                <img src={malls} alt="SHOPPING CENTERS & MALLS" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + malls + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.centros_comerciales.count} malls in sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/malls" className={classes.dropdownLink}>
                  SHOPPING CENTERS & MALLS
                </Link>
              </h4>
              <p className={classes.description}>
                Bring a modern approach to new development marketing and sales. From boutique rental conversions to luxurious ground-up condominiums, browse our portfolio of current offerings...
                <Link to="/malls" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>



        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="residential">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/residential" className={classes.dropdownLink}>
                <img src={residential} alt="Residential" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + residential + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.viviendas.count} residential houses for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/residential" className={classes.dropdownLink}>
                  RESIDENTIAL
                </Link>
              </h4>
              <p className={classes.description}>
                INVESTORS, INVESTMENTS , DEAL SOURCING
With specialists and partners working across all property sectors, we are able to advise all types of client on investment opportunities in all corners of the Spain...
                <Link to="/residential" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="n_d">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/new_development_properties" className={classes.dropdownLink}>
                <img src={new_developments} alt="Lands" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + new_developments + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.promociones.count} new develppment properties for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/new_development_properties" className={classes.dropdownLink}>
                  NEW DEVELOPMENTS
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide commercial, residential valuations
to all types of client...
                <Link to="/new_development_properties" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="rural_lands">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/rural_lands" className={classes.dropdownLink}>
                <img src={ruralLands} alt="Lands" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + ruralLands + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.fincas.count} rural lands for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/rural_lands" className={classes.dropdownLink}>
                  RURAL LANDS
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide commercial, residential valuations
to all types of client...
                <Link to="/rural_lands" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="lands">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/urban_lands" className={classes.dropdownLink}>
                <img src={urbanLands} alt="Lands" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + urbanLands + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.suelos.count} urban lands for sale</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/urban_lands" className={classes.dropdownLink}>
                  URBAN LANDS
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide commercial, residential valuations
to all types of client...
                <Link to="/urban_lands" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="investments">
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/investments" className={classes.dropdownLink}>
                <img src={investments} alt="..." />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + investments + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.proyectos.count} investment oportunities </h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/investments" className={classes.dropdownLink}>
                  INVESTMENTS
                </Link>
              </h4>
              <p className={classes.description}>
                From a valuation, land sales and adquisitions throught to funding and portfolio support, we work over all the process...
                <Link to="/investments" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>



        <GridItem xs={12} sm={4} md={4} lg={4} xl={4} id="ops">
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/offer" className={classes.dropdownLink}>
                <img src={bo_offer} alt="Lands" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + bo_offer + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>We have {stats.operaciones_oferta.count} business oportunities on the go</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/offer" className={classes.dropdownLink}>
                  BUSINESS OPORTUNITIES
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide commercial, residential valuations
to all types of client...
                <Link to="/offer" className={classes.dropdownLink}>Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>



        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionInterestedStyle)(SectionProperties);
